import { isActiveAdminUser } from '@amore/shared'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { AppLayout } from '@/features/app-shell/components/app-layout'
import { workspaceQueryOptions } from '@/lib/workspace'

export const Route = createFileRoute('/_auth/w/$workspaceSlug')({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(workspaceQueryOptions(params.workspaceSlug)),
  component: WorkspaceRoute,
})

function WorkspaceRoute() {
  const { workspaceSlug } = Route.useParams()
  const { session } = Route.useRouteContext()
  const workspaceQuery = useQuery(workspaceQueryOptions(workspaceSlug))
  const wedding = workspaceQuery.data?.wedding
  const weddingName = wedding?.name ?? workspaceQuery.data?.workspace.name ?? 'Naše svatba'
  const userName = session.user.name?.trim() || session.user.email || 'Uživatel'

  return (
    <AppLayout
      weddingName={weddingName}
      userName={userName}
      isPlatformAdmin={isActiveAdminUser(session.user, Date.now())}
      workspaceSlug={workspaceSlug}
      role={workspaceQuery.data?.role ?? 'viewer'}
    >
      <Outlet />
    </AppLayout>
  )
}
